import * as React from 'react';
import i18n from 'i18next';

/* eslint-disable @typescript-eslint/naming-convention -- TODO: rewrite as a hook */
export const onBeforeUnload = (Target: any) => {
    return class OnBeforeUnload extends React.Component<any, any> {
        public static displayName = `OnBeforeUnload(${getDisplayName(Target)})`;

        componentDidMount() {
            if (window) {
                window.onbeforeunload = () => this.promptOnUnsavedChanges();
            }
        }

        componentWillUnmount() {
            if (window) {
                window.onbeforeunload = null;
            }
        }

        promptOnUnsavedChanges() {
            const { isDirty } = this.props;
            if (isDirty) {
                return i18n.t("UNSAVED_CHANGES_MESSAGE");
            }
        }

        render() {
            return (
                <Target { ...this.props }/>
            );
        }
    };
};

function getDisplayName(WrappedComponent: any) {
    return WrappedComponent.displayName || WrappedComponent.name || 'unnamed';
}
